import { createContext, useContext } from 'react'

export interface RootConfig {
  googleClientId: string
  apiBaseUrl: string
  stripePublishableKey: string
}

export const RootConfigContext = createContext<RootConfig | null>(null)

export function useRootConfig() {
  const config = useContext(RootConfigContext)
  if (!config) {
    throw new Error('useRootConfig must be used within RootConfigProvider')
  }
  return config
}
